<template>
  <el-form>
    <!-- Dispositivo -->
    <el-form-item>
      <el-select 
        v-model="formData.deviceId" 
        :value-key="'id'" 
        filterable 
        :placeholder="$t('device.device')" 
        size="large" 
        :no-data-text="$t('NO_DATA_TEXT')" 
        :no-match-text="$t('NO_MATCH_TEXT')"
      >
        <el-option
          v-for="item in store.state.devices.deviceList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
  
    <!-- Fechas -->
    <div style="display: flex;">
      <div style="width: 100px"></div>
      <el-input 
        v-model="formData.date[0]" 
        type="datetime-local"
        placeholder="Fecha Inicio"
      />
      <el-input 
        v-model="formData.date[1]" 
        type="datetime-local"
        placeholder="Fecha Fin"
      />
    </div>
    
     
    <!-- Botones con Validación -->
    <div style="display: flex; justify-content: flex-end; margin-top: 3px;">
      <div style="margin-left: 30px; margin-top: 0px;">
        <el-switch 
          v-model="showRouteMarkers" 
          :active-text="$t('report.showMarkers')"
        />
      </div>
  
      <el-button 
        type="info" 
        :disabled="!formData.deviceId || !formData.date[0] || !formData.date[1]" 
        @click="loadRoute(false, true)"
      >
        {{ $t('report.export') }}
      </el-button>
  
      <el-button 
        type="primary" 
        :disabled="!formData.deviceId || !formData.date[0] || !formData.date[1]" 
        @mouseleave="hideTip" 
        @mouseenter.stop="showTip($event, $t('device.routes'))" 
        @click="loadRoute()"
      >
        <i class="fas fa-route"></i>
      </el-button>
  
      <el-button 
        type="info" 
        @mouseleave="hideTip" 
        @mouseenter.stop="showTip($event, $t('device.graphic'))" 
        :disabled="!formData.deviceId || !formData.date[0] || !formData.date[1]" 
        @click="loadGraph()"
      >
        <i class="fas fa-chart-bar"></i>
      </el-button>
  
      <el-button 
        type="primary" 
        :loading="isLoading" 
        :disabled="!formData.deviceId || !formData.date[0] || !formData.date[1]" 
        @click="handleGeneratePDF"
      >
        Generar PDF
      </el-button>
    </div>
  </el-form>
  

  <div  style="display: flex;flex-direction: column;border: var(--el-border-color-light) 1px solid;margin-top: 20px;border-radius: 10px;">
    <template v-if="loading">

      <div style="text-align: center;padding: 40px;">{{$t('LOADING')}}</div>
    </template>
    <template v-else-if="routePoints.length===0">
      <div style="text-align: center;padding: 40px;">{{$t('route.empty')}}</div>
    </template>
    <template v-else>




      <div v-if="routePoints.length > 0" style="border-bottom: silver 1px dotted; display: flex;">
        <div style="text-align: right; padding: 10px; font-size: 11px; color: #5b5b5b; position: relative; width: 70px;">
          <div style="position: absolute; border-right: #cbcbcb 1px dashed; width: 1px; height: 55%; right: 3px; bottom: 0%; transform: translate(-55%, 0)"></div>
          <div style="position: absolute; width: 20px; height: 20px; font-size: 16px; text-align: center; right: -10px; top: 50%; border-radius: 50%; transform: translateY(-50%)">
            <i class="fas fa-flag"></i>
          </div>
          <div style="position: absolute; right: 15px; top: 50%; border-radius: 50%; transform: translateY(-50%)">
            {{ new Date(routePoints[0].fixTime).toLocaleDateString() }}<br>
            {{ new Date(routePoints[0].fixTime).toLocaleTimeString() }}
          </div>
        </div>
      
        <div style="padding: 10px; font-size: 14px; flex: 1;">{{ routePoints[0].address }}</div>
      
        <div style="padding: 10px; width: 70px; text-align: right; font-size: 12px; margin-right: 1px;">
          <i class="fas fa-tachometer-alt"></i>
          {{$t('units.' + store.getters['server/getAttribute']('speedUnit', 'speedUnit'), { speed: routePoints[0].speed })}}
      
          <!-- Mostrar iconos para ignition, blocked y power de la primera posición -->
          <div style="display: flex; margin-top: 5px;">
            <!-- Ícono de ignition -->
            <i v-if="routePoints[0].attributes.ignition !== undefined" 
               :class="{
                 'fas fa-key': true,
                 'text-success': routePoints[0].attributes.ignition === true,  // verde si ignition es true
                 'text-danger': routePoints[0].attributes.ignition === false, // rojo si ignition es false
                 'text-muted': routePoints[0].attributes.ignition === undefined // gris si ignition no está presente
               }" style="margin-left: 5px; font-size: 8px;">
            </i>
      
            <!-- Ícono de bloqueo -->
            <i v-if="routePoints[0].attributes.blocked !== undefined" 
               :class="{
                 'fas fa-lock': true,
                 'text-success': routePoints[0].attributes.blocked === false, // verde si blocked es false (desbloqueado)
                 'text-danger': routePoints[0].attributes.blocked === true,  // rojo si blocked es true (bloqueado)
                 'text-muted': routePoints[0].attributes.blocked === undefined // gris si blocked no está presente
               }" style="margin-left: 5px; font-size: 8px;">
            </i>
      
            <!-- Ícono de power -->
            <i v-if="routePoints[0].attributes.power !== undefined" 
               class="fas fa-car-battery"
               :class="{
                 'text-success': routePoints[0].attributes.power > 0, // verde si power es positivo
                 'text-muted': routePoints[0].attributes.power <= 0 // gris si power es 0 o negativo
               }" 
               style="margin-left: 5px; font-size: 8px;">
            </i>
            <span v-if="routePoints[0].attributes.power !== undefined" 
            style="margin-left: 1px; font-size: 7px;">
              {{ (parseFloat(routePoints[0].attributes.power)).toFixed(1) }} V
            </span>
            
          </div>
        </div>
      </div>
      




      <div v-if="routePoints.length>2" style="overflow: auto;height: calc(100vh - 300px)">
        <template v-for="(p, k) in routePoints" :key="p.id">
          <div v-if="k > 0 && k < routePoints.length - 1" style="display: flex; border-bottom: silver 1px dotted;">
            <div style="text-align: right; padding: 10px; font-size: 11px; color: #5b5b5b; position: relative; width: 70px;">
              <div style="position: absolute; border-right: #cbcbcb 1px dashed; width: 1px; height: 100%; right: 3px; bottom: 0%; transform: translate(-55%,0)"></div>
              <div style="position: absolute; background: #05a7e3; width: 10px; height: 10px; right: 0px; top: 50%; border-radius: 50%; transform: translateY(-50%)"></div>
              <div style="position: absolute; right: 15px; top: 50%; border-radius: 50%; transform: translateY(-50%)">
                {{ new Date(p.fixTime).toLocaleDateString() }}<br>
                {{ new Date(p.fixTime).toLocaleTimeString() }}
              </div>
            </div>
        
            <div style="padding: 10px; font-size: 12px; flex: 1;">
              <a target="_blank" style="text-decoration: none; color: var(--el-text-color-primary)" :href="'https://maps.google.com/?q=' + p.latitude + ',' + p.longitude">
                {{ p.address || p.latitude + ',' + p.longitude }} 
                <i class="fas fa-external-link-alt"></i>
              </a>
            </div>
        
            <div style="padding: 10px; font-size: 12px; width: 70px; text-align: right">
              <i class="fas fa-tachometer-alt"></i>
              {{$t('units.' + store.getters['server/getAttribute']('speedUnit', 'speedUnit'), { speed: p.speed })}}
        
              <!-- Mostrar iconos para ignition, blocked y power, pero solo para esta posición (p) -->
              <div style="display: flex; margin-bottom: 10px;">
                <i v-if="p.attributes.ignition !== undefined" 
                   :class="{
                     'fas fa-key': true,
                     'text-success': p.attributes.ignition === true,  // verde si ignition es true
                     'text-danger': p.attributes.ignition === false, // rojo si ignition es false
                     'text-muted': p.attributes.ignition === undefined // gris si ignition no está presente
                   }" style="margin-left: 5px; font-size: 8px;">
                </i>
        
                <i v-if="p.attributes.blocked !== undefined" 
                   :class="{
                     'fas fa-lock': true,
                     'text-success': p.attributes.blocked === false, // verde si blocked es false (desbloqueado)
                     'text-danger': p.attributes.blocked === true,  // rojo si blocked es true (bloqueado)
                     'text-muted': p.attributes.blocked === undefined // gris si blocked no está presente
                   }" style="margin-left: 5px; font-size: 8px;">
                </i>
        
                <i v-if="p.attributes.power !== undefined" 
                class="fas fa-car-battery"
                :class="{
                  'text-success': p.attributes.power > 0, // verde si power es positivo
                  'text-muted': p.attributes.power <= 0 // gris si power es 0 o negativo
                }" 
                style="margin-left: 5px; font-size: 8px;">
             </i>
             <span v-if="p.attributes.power !== undefined" 
             style="margin-left: 1px; font-size: 7px;">
               {{ (parseFloat(p.attributes.power)).toFixed(1) }} V
             </span>
             
              </div>
            </div>
          </div>
        </template>
        
      
      <div v-if="routePoints.length > 0" style="border-top: silver 1px dotted; display: flex;">
        <div style="text-align: right; padding: 10px; font-size: 11px; color: #5b5b5b; position: relative; width: 70px;">
          <div style="position: absolute; border-right: #cbcbcb 1px dashed; width: 1px; height: 55%; right: 3px; top: 0%; transform: translate(-55%, 0)"></div>
          <div style="position: absolute; width: 20px; height: 20px; font-size: 16px; text-align: center; right: -10px; top: 50%; border-radius: 50%; transform: translateY(-50%)">
            <i class="fas fa-flag"></i>
          </div>
          <div style="position: absolute; right: 15px; top: 50%; border-radius: 50%; transform: translateY(-50%)">
            {{ new Date(routePoints[routePoints.length-1].fixTime).toLocaleDateString() }}<br>
            {{ new Date(routePoints[routePoints.length-1].fixTime).toLocaleTimeString() }}
          </div>
        </div>
      
        <div style="padding: 10px; font-size: 14px; flex: 1;">{{ routePoints[routePoints.length-1].address }}</div>
      
        <div style="padding: 10px; font-size: 12px; width: 70px; text-align: right; margin-right: 1px;">
          <i class="fas fa-tachometer-alt"></i>
          {{$t('units.' + store.getters['server/getAttribute']('speedUnit', 'speedUnit'), { speed: routePoints[routePoints.length-1].speed })}}
      
          <!-- Mostrar iconos para ignition, blocked y power del último punto -->
          <div style="display: flex; margin-top: 5px;">
            <!-- Ícono de ignition -->
            <i v-if="routePoints[routePoints.length-1].attributes.ignition !== undefined" 
               :class="{
                 'fas fa-key': true,
                 'text-success': routePoints[routePoints.length-1].attributes.ignition === true,  // verde si ignition es true
                 'text-danger': routePoints[routePoints.length-1].attributes.ignition === false, // rojo si ignition es false
                 'text-muted': routePoints[routePoints.length-1].attributes.ignition === undefined // gris si ignition no está presente
               }" style="margin-left: 5px; font-size: 8px;">
            </i>
      
            <!-- Ícono de bloqueo -->
            <i v-if="routePoints[routePoints.length-1].attributes.blocked !== undefined" 
               :class="{
                 'fas fa-lock': true,
                 'text-success': routePoints[routePoints.length-1].attributes.blocked === false, // verde si blocked es false (desbloqueado)
                 'text-danger': routePoints[routePoints.length-1].attributes.blocked === true,  // rojo si blocked es true (bloqueado)
                 'text-muted': routePoints[routePoints.length-1].attributes.blocked === undefined // gris si blocked no está presente
               }" style="margin-left: 5px; font-size: 8px;">
            </i>
      
            <!-- Ícono de power -->
            <i v-if="routePoints[routePoints.length-1].attributes.power !== undefined" 
   class="fas fa-car-battery"
   :class="{
     'text-success': routePoints[routePoints.length-1].attributes.power > 0, 
     'text-muted': routePoints[routePoints.length-1].attributes.power <= 0
   }" 
   style="margin-left: 10px; font-size: 8px;">
</i>
<span v-if="routePoints[routePoints.length-1].attributes.power !== undefined" 
style="margin-left: 1px; font-size: 7px;">
  {{ (parseFloat(routePoints[routePoints.length-1].attributes.power)).toFixed(1) }} V
</span>
          </div>
        </div>
      </div>
    </div>
      
    </template>
  </div>
</template>

<script setup>
 

  
    




import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/icon/style/css'
import 'element-plus/es/components/tooltip/style/css'
import 'element-plus/es/components/form/style/css'
import 'element-plus/es/components/form-item/style/css'
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/option/style/css'
import 'element-plus/es/components/switch/style/css'
import 'element-plus/es/components/input/style/css'

import { ElButton, ElForm, ElSelect, ElOption, ElFormItem, ElSwitch, ElInput } from "element-plus";
import { ref, inject, onMounted, watch, onBeforeUnmount, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { saveAs } from "file-saver";

import L from 'leaflet';
import 'jspdf-autotable';
//import '@fortawesome/fontawesome-free/css/all.css';
//import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLock, faLockOpen, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

// Agregar iconos a la librería
library.add(faLock, faLockOpen, faCircleNotch);
// Importar html2canvas
//import html2canvas from 'html2canvas';
import html2pdf from "html2pdf.js";



import dayjs from 'dayjs';
const showGraphicsRef = inject("show-graphics");
const loading = ref(false);
const date1 = new Date();
const date2 = new Date();
date1.setHours(0);
date1.setMinutes(0);
const showRouteMarkers = inject("showRouteMarkers");

const formData = ref({ deviceId: '', date: [date1, date2] });
const store = useStore();
const route = useRoute();
const routePoints = ref([]);

// Definición de la función showTip
const showTip = (evt, text) => {
  window.$showTip(evt, text); // Asegúrate de que esta función esté disponible
};

// Definición de la función hideTip
const hideTip = (evt) => {
  window.$hideTip(evt); // Asegúrate de que esta función esté disponible
};

onMounted(() => {
  if (route.query.deviceId) {
    formData.value.deviceId = parseInt(route.query.deviceId);
    loadRoute();
  }
});

onBeforeUnmount(() => {
  // Puedes agregar lógica de limpieza aquí si es necesario
});

watch(() => route.query.deviceId, () => {
  if (route.query.deviceId) {
    formData.value.deviceId = parseInt(route.query.deviceId);
    loadRoute();
  }
});

const updateRoute = inject('updateRoute');

const loadGraph = () => {
  if (routePoints.value.length === 0) {
    loadRoute(true);
  } else {
    showGraphicsRef.value.showGraphic(routePoints.value);
  }
};

const loadRoute = (g = false, e = false) => {
  const $traccar = window.$traccar;
  loading.value = true;

  $traccar.loadRoute(formData.value.deviceId, formData.value.date[0], formData.value.date[1], e).then((r) => {
    loading.value = false;
    
    if (e) {
      // Lógica para exportar a Excel o PDF
      if (r['headers']['content-type'] === 'application/pdf') {
        saveAs(new Blob([r.data], { type: 'application/pdf' }), 'resume.pdf');
      } else {
        saveAs(new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'resume.xlsx');
      }
    } else {
      // Guardar datos de la ruta
      routePoints.value = r.data;
      let tmp = [];
      r.data.forEach((p) => {
        tmp.push([p.latitude, p.longitude, p.id, p.course]);
      });
      updateRoute(tmp);
      
      nextTick(() => {
        hideDevices(formData.value.deviceId);
      });

      // Cargar el gráfico si es necesario
      if (g && r.data.length > 0) {
        loadGraph();
      }
    }
  });
};

// Función para ocultar dispositivos
const hideDevices = (deviceId = 0) => {
  store.dispatch("devices/setDeviceFilter", deviceId);
};






//import jsPDF from 'jspdf';

//import leafletImage from 'leaflet-image'; // Asegúrate de tener esta librería instalada


const generatePDF = async () => {
  
  if (routePoints.value.length === 0) {
    console.error("No hay datos de ruta disponibles.");
    return;
  }

  const deviceId = formData.value.deviceId;
  const deviceData = await fetchDeviceById(deviceId);
  if (!deviceData) {
    console.error("No se pudo obtener los datos del dispositivo.");
    return;
  }

  const deviceUniqueId = deviceData.uniqueId || "No disponible"; // ID único del dispositivo
  const deviceImage = deviceData.attributes.imageUrl || '/img/car.png'; // Foto del dispositivo
  const devicePlaca = deviceData.attributes.placa || "No disponible"; // Placa del dispositivo
  const deviceProtocolo = routePoints.value.protocol || "No disponible"; // Protocolo del dispositivo
  const deviceIccid = deviceData.attributes.iccid || "No disponible"; // ICCID
  const deviceCategory = deviceData.category || "No disponible"; // Categoría
  const devicename = deviceData.name || "No disponible"; // Categoría

  // Cálculos de la ruta
  const totalDistanceNM = routePoints.value.reduce((sum, point) => sum + point.attributes.distance, 0) / 1852;
  const totalDistanceKm = totalDistanceNM * 1.852;
  const totalDistance = totalDistanceKm.toFixed(2);

  const startTime = dayjs(routePoints.value[0].deviceTime);
  const endTime = dayjs(routePoints.value[routePoints.value.length - 1].deviceTime);
  const duration = `${startTime.format('DD/MM/YYYY HH:mm:ss')} - ${endTime.format('DD/MM/YYYY HH:mm:ss')}`;
  
  const maxSpeed = Math.max(...routePoints.value.map(point => point.speed || 0));
  const avgSpeed = totalDistanceKm / routePoints.value.length;

  const maxSpeedRounded = Math.round(maxSpeed);
  const avgSpeedRounded = Math.round(avgSpeed);

  const analyzedPeriod = `${startTime.format('DD/MM/YYYY')} - ${endTime.format('DD/MM/YYYY')}`;
  const dataCount = routePoints.value.length;

  // Calcular duración de parada y odómetro
  const stopDuration = calculateStopDuration(routePoints.value); // Duración de parada (en horas)
  const odometer = totalDistance; // El odómetro será igual a la distancia total en km

  // Crear el HTML para el informe
let reportHTML = `
<html>
<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css">
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 9px;
      margin: 0;
      padding: 0;
    }
    h1, h2 {
      color: #333;
    }
    .header-section {
      margin: 0;
      padding: 10px;
      background-color: #EDEDED;  /* Gris claro */
      border: 2px solid #b6b8b9;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .header-left {
      display: flex;
      align-items: center; /* Alinea la foto y la primera columna */
    }
    .header-left div {
      margin-bottom: 5px;
    }
    .device-photo {
      width: 1.75cm;
      height: 1.75cm;
      border-radius: 0%;
      object-fit: cover;
    }
    .info-text {
      font-size: 7;
      margin: 5px 0;
    }
    .info-block {
      margin-left: 10px; /* Espacio entre la foto y la primera columna de texto */
    }
    .info-block strong {
      font-weight: bold;
      color: #495057;
    }
    .title-report {
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #495057;
    }
    .columns {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
    }
    .column {
      width: 30%;
    }
    
    .map-container-wrapper {
      border: 2px solid #b6b8b9; /* Borde gris */
      border-radius: 10px; /* Bordes redondeados */
      padding: 10px; /* Espacio dentro del borde */
      margin-top: 20px; /* Espacio superior entre el mapa y los elementos previos */
      margin-bottom: 20px; /* Espacio inferior entre el mapa y la tabla */
      overflow: hidden; /* Para que el mapa respete las esquinas redondeadas */
    }
    
    .map-container {
        width: 215mm;
      height: 85mm;
      border-radius: 10px; /* Asegura que el mapa tenga bordes redondeados iguales al contenedor */
      position: relative;
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 30px;
    }
    .table th, .table td {
      padding: 4px;
      text-align: left;
      border-bottom: 1px solid #ddd;
      font-size: 6px;
    }
    .table th {
      background-color: #f1f1f1;
    }
    
    .metrics-container {
      background-color: #ffffff;
      border: 2px solid #b6b8b9;
      border-radius: 10px;
      padding: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      margin-top: 0;  /* Sin espacio entre cajas */
    }
    .metrics-container .column {
      padding: 5px 10px;
    }
    .metrics-container div {
      margin-bottom: 8px;
    }
    .metrics-container strong {
      font-size: 12px;
      color: #495057;
    }
    .ignition-unknown {
      color: gray;
    }

    .ignition-on {
      color: green;
    }

    .ignition-off {
      color: red;
    }

    .lock-unknown {
      color: gray;
    }

    .lock-on {
      color: red;
    }

    .lock-off {
      color: green;
    }

    .outside-header {
      display: flex;
      justify-content: space-between;
      padding: 5px 20px;
    }

    .left-text, .right-text {
      font-size: 8px;
    }

    /* Estilos para el pie de página */
    .footer-section {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      border-top: 2px solid #b6b8b9;
      margin-top: 20px;
      font-size: 8px;
    }

    .footer-left {
      text-align: left;
    }

    .footer-right {
      text-align: right;
    }

  </style>
</head>
<body>
  <!-- Datos fuera de la caja gris -->
  <div class="outside-header">
    <div class="left-text">
      <div><strong>Informe Histórico</strong></div>
    </div>
    <div class="right-text">
      <div><strong>Período Analizado:</strong> ${duration}</div>
      <div><strong>Cantidad de Datos Analizados:</strong> ${dataCount}</div>
    </div>
  </div>
  
  <!-- Caja gris con información del dispositivo y el nombre del informe -->
  <div class="header-section">
    <!-- Foto del dispositivo y primera columna juntos a la izquierda -->
    <div class="header-left">
      <img src="${deviceImage}" alt="Foto del Dispositivo" class="device-photo">
      <div class="info-block">
        <div class="info-text"><strong>Placa:</strong> ${devicePlaca}</div>
        <div class="info-text"><strong>IMEI:</strong> ${deviceUniqueId}</div>
        <div class="info-text"><strong>ID Dispositivo:</strong> ${deviceId}</div>
        <div class="info-text"><strong>Nombre:</strong> ${devicename}</div>
      </div>
    </div>

    <!-- Segunda columna de datos -->
    <div class="info-block" style="margin-left: 20px;">
      <div class="info-text"><strong>ICCID:</strong> ${deviceIccid}</div>
      <div class="info-text"><strong>Categoría:</strong> ${deviceCategory}</div>
      <div class="info-text"><strong>Protocólo:</strong> ${deviceProtocolo}</div>
    </div>
  </div>

  <!-- Caja blanca con los cálculos y métricas -->
  <div class="metrics-container">
    <div class="columns">
      <div class="column">
        <div><strong>Distancia del Recurso:</strong> ${totalDistance} km</div>
        <div><strong>Duración del Recurso:</strong>  ${analyzedPeriod}</div>
        <div><strong>Duración de Parada:</strong> ${stopDuration} horas</div>
      </div>
      <div class="column">
        <div><strong>Velocidad Máxima:</strong> ${maxSpeedRounded} km/h</div>
        <div><strong>Velocidad Media:</strong> ${avgSpeedRounded} km/h</div>
        <div><strong>Odómetro:</strong> ${odometer} km</div>
      </div>
      <div class="column">
        <div><strong>Tiempo de Motor:</strong> ${calculateEngineTime(routePoints.value)} horas</div>
      </div>
    </div>
  </div>

  <!-- Mapa -->
  <div class="map-container-wrapper">
    <div class="map-container" id="leafletMap">
      <h2>Mapa de la Ruta</h2>
    </div>
  </div>

  <!-- Detalle de la Ruta -->
  <h2>Detalle de la Ruta</h2>
  <table class="table">
    <thead>
      <tr>
        <th>Ignición</th>
        <th>Fecha</th>
        <th>Dirección</th>
        <th>Distancia (km)</th>
        <th>Velocidad (km/h)</th>
        <th>Combustible</th>
        <th>Conductor</th>
        <th>Bloqueo</th>
      </tr>
    </thead>
    <tbody>
    `;

  // Aquí se generan las filas de la tabla con los puntos de ruta
  routePoints.value.forEach((point) => {
    let ignitionClass = 'ignition-unknown';
    let ignitionText = 'Desconocido';
    if (point.attributes.ignition === true) {
      ignitionClass = 'ignition-on';  // Encendido (verde)
      ignitionText = 'Encendido';
    } else if (point.attributes.ignition === false) {
      ignitionClass = 'ignition-off'; // Apagado (rojo)
      ignitionText = 'Apagado';
    }

    let lockClass = 'lock-unknown';
    let lockText = 'Desconocido';
    if (point.attributes.blocked === true) {
      lockClass = 'lock-on';  // Candado cerrado (rojo)
      lockText = '';
    } else if (point.attributes.blocked === false) {
      lockClass = 'lock-off'; // Candado abierto (verde)
      lockText = '';
    }

    const lockIcon = point.attributes.blocked === true ? "fa-lock" : "fa-lock-open"; 

    const driverIcon = point.attributes.driverUniqueId
      ? `<i class="fas fa-user"></i> ${point.attributes.driverUniqueId}`
      : `<i class="fas fa-user-slash"></i> -`;

    const fuelValue = point.attributes.fuel;
    const roundedFuel = fuelValue 
        ? `<i class="fas fa-gas-pump"></i>${(parseFloat(fuelValue).toFixed(2))}` 
        : `<i class="fas fa-gas-pump"></i> -`;

    const distanceInKm = (point.attributes.distance / 1000).toFixed(2);
    const speedInKmH = Math.round(point.speed * 1.852);

    reportHTML += `
      <tr>
        <td><i class="fas fa-key ${ignitionClass}"></i> ${ignitionText}</td>
        <td><span class="time-bold">${dayjs(point.deviceTime).format('DD/MM/YYYY HH:mm:ss')}</span></td>
        <td>${point.address}</td>
        <td>${distanceInKm} km</td>
        <td>${speedInKmH} km/h</td>
        <td>${roundedFuel}</td>
        <td>${driverIcon}</td>
        <td><i class="fas ${lockIcon} ${lockClass}"></i> ${lockText}</td>
      </tr>
    `;
  });

  reportHTML += `
  </tbody>
  </table>

  <!-- Pie de Página -->
  <div class="footer-section">
    <div class="footer-left">Nombre de la Empresa</div>
    <div class="footer-right">Página 1 de X</div> <!-- Aquí deberás implementar la lógica para el conteo de páginas -->
  </div>

  </body>
  </html>`;


  // Crear el contenedor HTML para la conversión a PDF
  const reportContainer = document.createElement('div');
  reportContainer.innerHTML = reportHTML;
  document.body.appendChild(reportContainer);

  // Crear el mapa de Leaflet
  const map = L.map('leafletMap', {
    preferCanvas: true,
    zoomControl: false,
    attributionControl: false
  }).setView([routePoints.value[0].latitude, routePoints.value[0].longitude], 18);

  // Añadir capa de mapa de Google
  L.tileLayer('https://{s}.google.com/vt/lyrs=m@221097413&x={x}&y={y}&z={z}&hl=MA&gl=MA', {
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
  }).addTo(map);

  // Añadir la ruta
  const path = routePoints.value.map(point => [point.latitude, point.longitude]);
  L.polyline(path, { color: 'blue', weight: 1 }).addTo(map);
   // Añadir marcadores de inicio y fin
  L.marker([routePoints.value[0].latitude, routePoints.value[0].longitude]).addTo(map);
  L.marker([routePoints.value[routePoints.value.length - 1].latitude, routePoints.value[routePoints.value.length - 1].longitude]).addTo(map);


  // Ajustar los límites del mapa
  //map.fitBounds(L.latLngBounds(path));
  const bounds = L.latLngBounds(path);
  map.fitBounds(bounds, {
  paddingTopLeft: [10, 0],  // Añadir margen en la parte superior izquierda
  paddingBottomRight: [5, 0] // Añadir margen en la parte inferior derecha
 });

  // Esperar a que el mapa se renderice y luego generar el PDF
      return new Promise((resolve) => {
      setTimeout(() => {
        
        html2pdf(reportContainer, {
          filename: `${deviceId}_informe_historico.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { 
            scale: 2, 
            useCORS: true, 
            allowTaint: true,
          },
          
          jsPDF: {
            unit: 'mm',
            format: 'a4', 
            orientation: 'portrait', 
            margin: [15, 15, 15, 15],
          }
        });

        // Eliminar el contenedor temporal del DOM
        document.body.removeChild(reportContainer);
        
      }, 8000); 
      resolve();
    });


};




// Función para calcular duración de parada (en horas)
function calculateStopDuration(routePoints) {
  let stopDuration = 0;

  routePoints.forEach((point, index) => {
    if (index === 0) return; // Ignorar el primer punto

    const prevPoint = routePoints[index - 1];
    const speed = point.speed || 0;          // Velocidad actual
    const prevSpeed = prevPoint.speed || 0;  // Velocidad del punto anterior
    const ignition = point.ignition;         // Estado de la ignición
    const prevIgnition = prevPoint.ignition;
    const motion = point.motion || false;    // Estado de movimiento (true o false)
    const prevMotion = prevPoint.motion || false;
    const valid = point.valid;               // Estado de validez (true o false)
    const prevValid = prevPoint.valid;

    // Combinamos los criterios para detectar una parada:
    // 1. La velocidad es cercana a 0 (parada).
    // 2. El motor está apagado (ignition es false).
    // 3. El vehículo no se está moviendo (motion es false).
    // 4. El estado general es válido (valid debe ser true).
    if (
      Math.abs(speed) < 0.1 &&              // Velocidad cercana a cero
      Math.abs(prevSpeed) < 0.1 &&          // Velocidad previa cercana a cero
      (ignition === false || prevIgnition === false) && // Motor apagado
      (motion === false || prevMotion === false) && // Vehículo detenido
      (valid === false || prevValid === false) // Vehículo no válido (detenido)
    ) {
      // Calculamos la diferencia de tiempo en minutos entre el punto actual y el anterior
      const diffInMinutes = dayjs(point.deviceTime).diff(dayjs(prevPoint.deviceTime), 'minute');
      stopDuration += diffInMinutes / 60;  // Convertimos la diferencia de minutos a horas
    }
  });

  return stopDuration;
}

function calculateEngineTime(routePoints) {
  let engineTime = 0;

  // Primero verificamos si tenemos el campo hours en los puntos
  const firstPoint = routePoints[0];
  const lastPoint = routePoints[routePoints.length - 1];
  const firstPointHours = firstPoint?.attributes?.hours || 0;  // Hora del primer punto
  const lastPointHours = lastPoint?.attributes?.hours || 0;    // Hora del último punto

  // Si ambos primeros y últimos puntos tienen horas, las restamos
  if (firstPointHours && lastPointHours) {
    const hoursDifference = lastPointHours - firstPointHours;
    engineTime += hoursDifference;  // Sumamos la diferencia de horas entre el primer y último punto
  }

  // Ahora sumamos el tiempo de motor por cada punto con movimiento
  routePoints.forEach((point) => {
    const speed = point.speed || 0;
    if (speed > 0) {
      engineTime += 1; // Se cuenta como 1 hora de motor por cada punto con movimiento
    }
  });

  return engineTime;
}




const fetchDeviceById = async (deviceId) => {
  try {
    const response = await fetch(`/api/devices/${deviceId}`); // Ajusta la URL según tu API
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    const data = await response.json();
    return data; // Retorna el objeto completo del dispositivo
  } catch (error) {
    console.error("Error al obtener el dispositivo:", error);
    return null; // Retorna null en caso de error
  }
}


// Definir la variable isLoading como una referencia reactiva
const isLoading = ref(false);


// Función que se llama al hacer clic en el botón
const handleGeneratePDF = async () => {
  isLoading.value = true; // Activamos el estado de carga
  try {
    await generatePDF(); // Llamamos a tu función ya construida para generar el PDF
  } catch (error) {
    console.error('Error al generar el PDF:', error);
  } finally {
    isLoading.value = false; // Desactivamos el estado de carga después de completar
  }
};





</script>

<style scoped>
.el-select.el-select--large {
  width: 100%;
}

.device {
  border-bottom: var(--el-border-color-light) 1px solid;
  display: flex;
  flex-direction: row;
  text-align: center;
  cursor: pointer;
  margin-right: -1px;
}

.deviceHead {
  border-bottom: var(--el-border-color-light) 1px solid;
  display: flex;
  flex-direction: row;
  text-align: center;
  cursor: pointer;
  margin-right: -1px;
  background: var(--el-color-info-light);
}

.device:hover {
  background: var(--el-color-primary-light-9);
}

.device .name,
.deviceHead .name {
  font-size: 12px;
  padding: 7px;
  text-align: left;
  line-height: 14px;
  font-weight: 800;
  border-right: silver 1px dotted;
  width: 60%;
}

.icons {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  flex: 1;
  font-size: 11px;
}

.icons div {
  display: flex;
  justify-content: center;
  flex: 1;
  border-right: silver 1px dotted;
  padding: 7px;
  font-size: 11px;
}

.icons div i {
  font-size: 14px;
}

.icons div:first-child {
  border-right: none;
}

.icons div span {
  display: flex;
  padding: 2px;
  padding-left: 5px;
}

.subtitle {
  margin-top: 20px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  color: var(--text-black);
}

.subtitle i {
  font-size: 12px;
  margin-right: 3px;
}

.map-container {
    margin: 20px auto; /* Centra el contenedor */
    display: none
}

.map {
    width: 100%; /* Ajusta al 100% del contenedor */
    height: 250px; /* Establece una altura fija */
    border-radius: 8px; /* Bordes redondeados */
}

/* Estilo de la animación del ícono de carga */
.custom-loading svg.circular {
  animation: spin 2s linear infinite; /* Aplicamos la animación */
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* Comienza en 0 grados */
  }
  100% {
    transform: rotate(360deg); /* Rota hasta 360 grados */
  }
}
.text-success {
  color: green;
}

.text-danger {
  color: red;
}
</style>
